import { createContext } from 'react'

export type BookingContextValue = {
  openBooking: () => void
}

export const BookingContext = createContext<BookingContextValue | null>(null)
